


























































































/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component, Vue,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import { AxiosError } from 'axios';
import Select from '@/components/Select.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
// import { DateRange } from '@/components/DatePicker.vue';
import hasPermission from '@/libs/permission';
import api from '@/libs/api';
import format from '@/libs/numberFormat';
import SearchIcon from 'mdi-vue/Magnify';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { MerchantBalance, MerchantBalanceResponse } from '@/libs/api.interfaces';
import Modal from '@/components/Modal.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Toggle from '@/components/Toggle.vue';
// import ModalDetail from './components/ModalDetail.vue';

interface ReportParams {
  merchant: string;
  merchant_code: string;
  year: LabelValue | null;
  status: LabelValue | null;
  export: boolean;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
    SearchIcon,
    Modal,
    Select,
    LayoutContent,
    Toggle,
    // ModalDetail,
  },
  methods: {
    format,
    hasPermission,
  },
})
export default class ReportTable extends Vue {
  channel = { title: '', code: '', path: '' };

  loading = true;
  selectedItem = {};
  history: MerchantBalance[] = [];

  showModal = false;
  merchant_code = '';
  status = false;
  year = false;

  format!: (val: string) => string;

  async getTransaction(params: ReportParams, isExport = false) {
    // console.log('HIT');
    this.loading = true;
    if (isExport) {
      await api.get('/prepaid/history/balance/month', {
        params: {
          status: params.status === null ? undefined : params.status?.value,
          year: params.year === null ? undefined : params.year?.value,
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_name: params.merchant,
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_code: params.merchant_code === null ? undefined : params.merchant_code,
          export: isExport || undefined,
        },
        responseType: 'arraybuffer',
      }).then((response) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data]),
        );
        let filename = '';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        const currentdate = new Date();
        const datetime = `${currentdate.getDate()}${
          currentdate.getMonth() + 1}${
          currentdate.getFullYear()}${
          currentdate.getHours()}${
          currentdate.getMinutes()}${
          currentdate.getSeconds()}`;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename || `Merchant_Balance${datetime}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });

      this.getTransaction(params, false);
      return null;
    }

    try {
      this.loading = true;
      const { data } = await api.get<MerchantBalanceResponse>('/prepaid/history/balance/month', {
        params: {
          status: params.status === null ? undefined : params.status?.value,
          year: params.year === null ? undefined : params.year?.value,
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_name: params.merchant,
          // eslint-disable-next-line @typescript-eslint/camelcase
          merchant_code: params.merchant_code === null ? undefined : params.merchant_code,
          // export: isExport || undefined,
        },
      });

      this.history = data.data;
      this.$emit('totalBalance', data.totalBalance);
      this.$emit('yearData', data.year);
      this.loading = false;

      return null;
    } catch (err) {
      console.error(err);
      // if (isExport) {
      //   const error = err as AxiosError;
      //   // console.log(error.response);
      //   showToast(ToastType.FAILED, 'Export Failed', error?.response?.data.error.message);
      // }
      throw err;
    }
  }

  toggleModal(data: any) {
    this.selectedItem = data;
    this.showModal = !this.showModal;
  }

  closeToggleModal() {
    this.showModal = false;
  }

  hasPermission!: (val: string | string[]) => boolean;

  async export(params: ReportParams) {
    showToast(ToastType.SUCCESS, 'Export Merchant Balance', 'Export is starting, please wait! This may take a while');
    try {
      const url = await this.getTransaction(params, true);
      // this.downloadSheet(url as string);
      showToast(ToastType.SUCCESS, 'Export Merchant Balance', 'Export finished');
    } catch (err) {
      // console.log(err);
      this.loading = false;
      showToast(ToastType.FAILED, 'Export Merchant Balance', 'Export failed');
    }
  }
}

